/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon20Regular = forwardRef('CheckAIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.986 4.626a.75.75 0 0 1 0 1.06l-8.54 8.541a2.734 2.734 0 0 1-3.868 0l-3.17-3.17a.75.75 0 1 1 1.06-1.061l3.17 3.17a1.234 1.234 0 0 0 1.746 0l8.541-8.54a.75.75 0 0 1 1.06 0Z" })));
});
